export interface TranslationErrorLogger {
  logError: (context: Record<string, unknown>) => void;
}

let errorLogger: TranslationErrorLogger | null = null;

/**
 * Set a custom error logger for translation errors (eg Datadog)
 */
export const setTranslationErrorLogger = (logger: TranslationErrorLogger) => {
  errorLogger = logger;
};

/**
 * Creates a fallback translation from the last part of the key
 * Example: "user.profile.settings.title" -> "Title"
 */
export const createFallbackTranslation = (key: string): string => {
  let fallbackText = '[Missing Translation]';

  const isKeyValidString = !!key && typeof key === 'string';

  if (isKeyValidString) {
    const parts = key.split('.');
    const lastPart = parts[parts.length - 1] || '';

    // Convert camelCase or snake_case to Title Case
    const formatted = lastPart
      // Handle camelCase: "userName" -> "User Name"
      .replace(/([A-Z])/g, ' $1')
      // Handle snake_case: "user_name" -> "User Name"
      .replace(/_/g, ' ')
      // Handle kebab-case: "user-name" -> "User Name"
      .replace(/-/g, ' ')
      // Capitalize first letter of each word
      .replace(/\b\w/g, char => char.toUpperCase())
      // Clean up extra spaces
      .replace(/\s+/g, ' ')
      .trim();

    if (formatted) {
      fallbackText = formatted;
    }
  }

  const logContext = {
    isKeyValidString,
    key,
    fallbackText,
    page: typeof window !== 'undefined' ? window.location.pathname : '',
    stackTrace: new Error().stack,
  };

  if (errorLogger) {
    errorLogger.logError(logContext);
  } else {
    console.warn('Translation error', logContext);
  }

  return fallbackText;
};
